export type PaidOfferingName = 'Standard' | 'Premium' | 'Business' | 'Business + AI';

export const normalisePaidOfferingName = (
	offeringName: string | undefined,
	productName?: string,
): PaidOfferingName | null => {
	switch (offeringName?.trim().toLowerCase()) {
		case 'standard':
			return 'Standard';
		case 'premium':
			return 'Premium';
		case 'business':
			return productName?.trim().toLowerCase() === 'loom' ? 'Business' : null;
		case 'business + ai':
			return productName?.trim().toLowerCase() === 'loom' ? 'Business + AI' : null;
		default:
			return null;
	}
};
